module.exports = __webpack_public_path__ + "img/黑龙江.676583b9.png";